"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthIcon = void 0;
var react_1 = __importDefault(require("react"));
var EthIcon = function () {
    return (react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("circle", { cx: "8", cy: "8", r: "8", fill: "#EDF0F4" }),
        react_1.default.createElement("path", { d: "M7.9777 3.19922L7.91406 3.41539V9.68762L7.9777 9.75111L10.8891 8.03013L7.9777 3.19922Z", fill: "#343434" }),
        react_1.default.createElement("path", { d: "M7.97792 3.19922L5.06641 8.03013L7.97792 9.75111V6.70674V3.19922Z", fill: "#8C8C8C" }),
        react_1.default.createElement("path", { d: "M7.97727 10.3021L7.94141 10.3459V12.5801L7.97727 12.6848L10.8905 8.58203L7.97727 10.3021Z", fill: "#3C3C3B" }),
        react_1.default.createElement("path", { d: "M7.97792 12.6848V10.3021L5.06641 8.58203L7.97792 12.6848Z", fill: "#8C8C8C" }),
        react_1.default.createElement("path", { d: "M7.97656 9.7514L10.888 8.03042L7.97656 6.70703V9.7514Z", fill: "#141414" }),
        react_1.default.createElement("path", { d: "M5.06641 8.03042L7.97792 9.7514V6.70703L5.06641 8.03042Z", fill: "#393939" })));
};
exports.EthIcon = EthIcon;
